import { TBX_ENVS } from "../config";
import { THUMB_OR_POSTER } from "../constants/imageMode";

export const getContentImageByMode = (imagesArray, mode) => {
  mode = THUMB_OR_POSTER[mode]
  let image = null;
  if(!Array.isArray(imagesArray) || typeof mode !== 'string') return undefined;
  for (let i = 0; i < imagesArray.length; i++) {
    if (imagesArray[i].type === mode) { 
      image = imagesArray[i];
      break;
    }
  }
  return image;
};


export const getUrlUnityImageApi = (url) => {
  const TBX_UNITY_IMAGES_API = TBX_ENVS.TBX_UNITY_IMAGES_API
  if(!TBX_UNITY_IMAGES_API || typeof url !== 'string') return url;
  return url.replace('TBX_UNITY_IMAGES_API',TBX_UNITY_IMAGES_API)
};